import React, { useEffect } from "react";
import constitutionthree from "../../../imagestwo/thetribunalslogotwo.jpeg";
import "./mainheader.css";
import Aos from "aos";
import "aos/dist/aos.css";
import useCmsContent from "../../../hooks/useCmsContent";
import { getMainHeaderContent } from "../../../lib/strapi/phaseTwoContent";

const fallbackMainHeader = {
  heading: "TRIBUNALS IN KENYA",
  quote:
    "Judicial authority vests in and is to be exercised by courts and tribunals established by or under the Constitution.",
  citation: "Article 159 (1) of the Constitution of Kenya.",
  logoImage: "",
};

function Mainheader() {
  const { data: mainHeader } = useCmsContent(
    getMainHeaderContent,
    fallbackMainHeader
  );

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="mainheader">
      <div className="mainheaderr_div">
        <div className="mainheaderr_div_heading">
          <h2>{mainHeader.heading}</h2>
        </div>
        <div className="mainheaderr-div_maincontent">
          <div className="mainheaderr-div_maincontent_logo">
            <img
              src={mainHeader.logoImage || constitutionthree}
              alt="Tribunals Logo"
            />
          </div>
          <div className="mainheaderr-div_maincontent_text">
            <p>"{mainHeader.quote}"</p>
            <h3>{mainHeader.citation}</h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mainheader;
